import { DeepMap } from 'react-hook-form';
import {
  JobsiteGatewayInput,
  JobsiteUpdateInput,
} from 'apollo/generated/client-operations';
import {
  FormInputTypes,
  getUpdateInputValueFunction,
  GridColSpan,
  TypedFormInputs,
} from 'components/form';
import { Gateways } from 'containers/jobsiteConfiguration/components';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { ensureNonUndefinedFields } from 'utils';
import { Jobsite } from './types';

export const getGatewaysSectionInputs = (): TypedFormInputs<
  EditJobsiteConfigurationFormData['gateways']
> => ({
  jobsiteGateways: {
    element: FormInputTypes.CustomInput,
    elementProps: { customInput: Gateways },
    layout: [GridColSpan.SpanFull],
  },
});

export const getGatewaysSectionDefaultValues = (
  jobsite: Jobsite,
): EditJobsiteConfigurationFormData['gateways'] => {
  const { jobsiteGateways } = jobsite ?? {};

  return {
    jobsiteGateways:
      jobsiteGateways?.edges.map(({ node: { id, name } }) => ({ id, name })) ??
      [],
  };
};

type GatewaysSectionUpdateInput = Required<
  Pick<JobsiteUpdateInput, 'jobsiteGateways'>
>;

export const getGatewaysSectionUpdateInput = (
  gateways: EditJobsiteConfigurationFormData['gateways'],
  dirtyFields: DeepMap<EditJobsiteConfigurationFormData['gateways'], true>,
): GatewaysSectionUpdateInput => {
  const getUpdateInputValue = getUpdateInputValueFunction(
    gateways,
    dirtyFields,
  );

  const jobsiteGateways = getUpdateInputValue('jobsiteGateways')?.filter(
    (a): a is JobsiteGatewayInput => !!a.changeType,
  );

  return ensureNonUndefinedFields<GatewaysSectionUpdateInput>({
    jobsiteGateways,
  });
};
